var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIosTimerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.799,
    height: 21.805,
    viewBox: "0 0 21.799 21.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-timer",
    "data-name": "Icon ionic-ios-timer",
    transform: "translate(-3.938 -3.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7398",
    "data-name": "Path 7398",
    d: "M14.84,25.742A10.9,10.9,0,0,1,7.274,6.99.875.875,0,1,1,8.489,8.249a9.15,9.15,0,1,0,7.223-2.518V9.143a.878.878,0,1,1-1.755,0V4.815a.877.877,0,0,1,.878-.878,10.9,10.9,0,0,1,.005,21.8Z",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7399",
    "data-name": "Path 7399",
    d: "M12.117,11.354l5.424,3.9a1.641,1.641,0,1,1-1.908,2.671,1.585,1.585,0,0,1-.382-.382l-3.9-5.424a.547.547,0,0,1,.763-.763Z",
    transform: "translate(-1.644 -1.644)",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosTimerIcon);
export default __webpack_public_path__ + "static/media/ios-timer-icon.d6a6a8b31c431821cf2ec440f8e2c537.svg";
export { ForwardRef as ReactComponent };